export default __webpack_public_path__ + "static/media/img-ltsh-2023.41ee504b.png";